import { useLanguage } from '../contexts/LanguageContext';
import { zh } from '../locales/zh';
import { en } from '../locales/en';

// 翻译资源映射
const translations = {
  zh,
  en
};

// 根据路径获取嵌套对象的值
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : null;
  }, obj);
};

// 翻译Hook
export const useTranslation = () => {
  const { currentLanguage } = useLanguage();
  
  // 获取当前语言的翻译资源
  const currentTranslations = translations[currentLanguage] || translations.zh;
  
  // 翻译函数
  const t = (key, fallback = '') => {
    const value = getNestedValue(currentTranslations, key);
    
    // 如果找到翻译，返回翻译值
    if (value !== null && value !== undefined) {
      return value;
    }
    
    // 如果没找到翻译，尝试从中文翻译中获取
    if (currentLanguage !== 'zh') {
      const zhValue = getNestedValue(translations.zh, key);
      if (zhValue !== null && zhValue !== undefined) {
        console.warn(`Missing translation for key "${key}" in language "${currentLanguage}"`);
        return zhValue;
      }
    }
    
    // 如果都没找到，返回fallback或key本身
    console.warn(`Missing translation for key "${key}"`);
    return fallback || key;
  };

  // 批量翻译函数
  const tBatch = (keys) => {
    const result = {};
    keys.forEach(key => {
      result[key] = t(key);
    });
    return result;
  };

  // 检查是否存在翻译
  const hasTranslation = (key) => {
    return getNestedValue(currentTranslations, key) !== null;
  };

  // 获取当前语言的所有翻译
  const getAllTranslations = () => currentTranslations;

  return {
    t,
    tBatch,
    hasTranslation,
    getAllTranslations,
    currentLanguage
  };
};

export default useTranslation;
